import { get, isEmpty, find, noop, debounce } from "lodash";
import { useEffect } from "react";
import Highlighter from "react-highlight-words";
// import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { Empty, Input, Spin, Table, Tooltip, Typography } from "antd";
// import { SearchOutlined } from "@ant-design/icons";
// import { Button, Space } from "antd";
import type { ColumnsType, ColumnType } from "antd/es/table";
// import type { FilterConfirmProps } from "antd/es/table/interface";
import moment from "moment";

import dashboardReport from "../../../../assets/images/dashboardReport.png";
import PatientProfileService from "@services/patientProfile.service";
import "./patientProfileReport.scss";
import MultiSelect from "@components/multiSelect/multiSelect";
import membersService from "@services/members.service";
import { routeMap } from "@utils/constants";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import { fixedDecimal, formatDisplayDate, formatPhoneNumber } from "@utils/helpers";
import Icon from "@assets/icon_config";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import RefreshData from "@components/refreshData/refreshData";
import classNames from "classnames";
import DataNotFound, { TableLocale } from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";

const { Text } = Typography;

/******************************************************************* */

const PatientProfileReport = () => {
  // states to store the data
  const patientList = usePatientProfileStore((state) => state.patientList);
  const setPatientList = usePatientProfileStore((state) => state.setPatientList);
  const patientData = usePatientProfileStore((state) => state.patientData);
  const setPatientData = usePatientProfileStore((state) => state.setPatientData);
  const patientOptionalData = usePatientProfileStore((state) => state.patientOptionalData);
  const setPatientOptionalData = usePatientProfileStore((state) => state.setPatientOptionalData);

  const patientPersonalData = usePatientProfileStore((state) => state.patientPersonalData);
  const setPatientPersonalData = usePatientProfileStore((state) => state.setPatientPersonalData);
  const patientTransactionalDetails = usePatientProfileStore((state) => state.patientTransactionalDetails);
  const setPatientTransactionalDetails = usePatientProfileStore((state) => state.setPatientTransactionalDetails);
  const patientPersonalDataGroup = usePatientProfileStore((state) => state.patientPersonalDataGroup);
  const setPatientPersonalDataGroup = usePatientProfileStore((state) => state.setPatientPersonalDataGroup);
  const patientTransactionalDataGroup = usePatientProfileStore((state) => state.patientTransactionalDataGroup);
  const setPatientTransactionalDataGroup = usePatientProfileStore((state) => state.setPatientTransactionalDataGroup);

  // const summaryData = usePatientProfileStore((state) => state.summaryData);
  // const setSummaryData = usePatientProfileStore((state) => state.setSummaryData);
  const dropDownOptions = usePatientProfileStore((state) => state.dropDownOptions);
  const setDropDownOptions = usePatientProfileStore((state) => state.setDropDownOptions);

  // const [isPatientListVisible, setIsPatientListVisible] = useState(false);
  // const [isPatientProfileVisible, setIsPatientProfileVisible] = useState(false);

  // states for loaders
  const isPatientListLoading = usePatientProfileStore((state) => state.isPatientListLoading);
  const setIsPatientListLoading = usePatientProfileStore((state) => state.setIsPatientListLoading);
  const isPatientProfileLoading = usePatientProfileStore((state) => state.isPatientProfileLoading);
  const setIsPatientProfileLoading = usePatientProfileStore((state) => state.setIsPatientProfileLoading);

  // states to store the active State
  const searchedName = usePatientProfileStore((state) => state.searchedName);
  const setSearchedName = usePatientProfileStore((state) => state.setSearchedName);
  const searchedId = usePatientProfileStore((state) => state.searchedId);
  const setSearchedId = usePatientProfileStore((state) => state.setSearchedId);
  const activePatientId = usePatientProfileStore((state) => state.activePatientId);
  const setActivePatientId = usePatientProfileStore((state) => state.setActivePatientId);
  const selectedOptions = usePatientProfileStore((state) => state.selectedOptions);
  const setSelectedOptions = usePatientProfileStore((state) => state.setSelectedOptions);
  const page = usePatientProfileStore((state) => state.page);
  const setPage = usePatientProfileStore((state) => state.setPage);
  const pageSize = usePatientProfileStore((state) => state.pageSize);
  const setPageSize = usePatientProfileStore((state) => state.setPageSize);
  const sort = usePatientProfileStore((state) => state.sort);
  const setSort = usePatientProfileStore((state) => state.setSort);

  // states for search in table
  // const searchText = usePatientProfileStore((state) => state.searchText);
  // const setSearchText = usePatientProfileStore((state) => state.setSearchText);
  // const searchedColumn = usePatientProfileStore((state) => state.searchedColumn);
  // const setSearchedColumn = usePatientProfileStore((state) => state.setSearchedColumn);

  // const searchInput = useRef<InputRef>(null);
  // const [selectedAdditionalFields, setSelectedAdditionalFields] = useState<any[]>([]);

  const navigate = useNavigate();

  // labels for highlighting
  const highlighted_labels = ["Total Cost"];
  interface DataType {
    patient_name: string;
    uId: number;
    patient_id: string;
  }

  type DataIndex = keyof DataType;

  const fetchMembersList = (memberName: any, memberId: any) => {
    console.log("PatientProfileReport.useEffect1");
    setSort({ column: "patient_name", order: "ascend" });
    setPage(1);
    if (memberName?.length >= 3 || memberId?.length >= 3) {
      setIsPatientListLoading(true);
      // call the API
      PatientProfileService.fetchPatientsList({ patient_name: memberName, uId: memberId }).subscribe({
        next: (v) => {
          const response = v?.data?.data;
          setPatientList(response);
          // setIsPatientListVisible(true);
          setIsPatientListLoading(false);
          if (response?.length > 0) {
            setActivePatientId(response?.[0]?.patient_id);
          } else {
            clearStates();
          }
        },
        error: (e) => {
          console.log(e);
          setIsPatientListLoading(false);
        },
      });
    } else if (memberName?.length === 0 && memberId?.length === 0) {
      clearStates();
    }
  };

  // Clearing Component states
  const clearStates = () => {
    setPatientList([]);
    setPatientData([]);
    setPatientPersonalData([]);
    setPatientTransactionalDetails([]);
    setDropDownOptions([]);
    setSelectedOptions(null);
    setActivePatientId([]);
  };

  useEffect(() => {
    console.log("PatientProfileReport.useEffect2");
    if (!isEmpty(activePatientId)) {
      setIsPatientProfileLoading(true);
      // call the API
      PatientProfileService.fetchPatientProfileData({ patient_id: activePatientId }).subscribe({
        next: (v) => {
          const response = v?.data?.data;

          const patient = response?.patient;
          const patient_personal_data = response?.patient_details;
          const transactional_details = response?.transactional_details;
          // const summary = response?.summary;

          //// patient.splice(3, 0, {additional : false});
          // adding selected optional labels/values
          let selectedOptionList: any = [];
          selectedOptions?.split("$|")?.forEach((item: any) => {
            const x = find(patientOptionalData, { label: item });
            selectedOptionList.push(x?.label);
          });
          setPatientData(patient.filter((item: any) => !item.additional || selectedOptionList?.includes(item?.label)));
          setPatientOptionalData([
            ...patient.filter((item: any) => item.additional),
            ...patient_personal_data.filter((item: any) => item?.additional),
            ...transactional_details.filter((item: any) => item?.additional),
          ]);

          setPatientPersonalData(patient_personal_data?.filter((item: any) => !item.additional || selectedOptionList?.includes(item?.label)));
          setPatientPersonalDataGroup(patient_personal_data?.map((item: any) => item?.label));
          setPatientTransactionalDetails(transactional_details.filter((item: any) => !item.additional || selectedOptionList?.includes(item?.label)));
          setPatientTransactionalDataGroup(transactional_details.map((item: any) => item?.label));

          let options = patient.filter((item: any) => item?.additional);
          options.push(...patient_personal_data.filter((item: any) => item?.additional));
          options.push(...transactional_details.filter((item: any) => item?.additional));

          const _options: any = [];
          options.forEach((element: { value: any; label: any }) => {
            _options.push({
              value: element.label,
              title: element.label,
            });
          });
          setDropDownOptions(_options);
          // setSummaryData(summary);
          // setSelectedOptions("");
          setIsPatientProfileLoading(false);
        },
        error: (e) => {
          console.log(e);
          setIsPatientProfileLoading(false);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activePatientId,
    setDropDownOptions,
    setIsPatientProfileLoading,
    setPatientData,
    setPatientOptionalData,
    setPatientPersonalData,
    setPatientPersonalDataGroup,
    setPatientTransactionalDataGroup,
    setPatientTransactionalDetails,
  ]);

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<DataType> => {
    let searchString = dataIndex === "patient_name" ? searchedName : searchedId;
    return {
      render: (text) => <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchString]} autoEscape textToHighlight={text ? text.toString() : ""} />,
    };
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Name",
      dataIndex: "patient_name",
      key: "patient_name",
      sorter: (a: any, b: any) => a["patient_name"].localeCompare(b["patient_name"]),
      sortOrder: sort.column === "patient_name" ? sort.order : null,
      ...getColumnSearchProps("patient_name"),
    },
    {
      title: "Insurance #",
      dataIndex: "uId",
      key: "uId",
      sorter: (a: any, b: any) => a["uId"].localeCompare(b["uId"]),
      sortOrder: sort.column === "uId" ? sort.order : null,
      width: "50%",
      ...getColumnSearchProps("uId"),
    },
  ];

  const goToMemberDetails = () => {
    setIsPatientProfileLoading(true);
    membersService.membersByIds([activePatientId]).subscribe({
      next: (v) => {
        let member = v?.data?.data?.patientList.pop();
        if (member) {
          membersService.setCurrentMember = member;
          membersService.setsingleMember = false;
          navigate(routeMap.memberProfile, { state: { from: routeMap.dashboard, fromLabel: "Reports / Patient Profile" } });
        }
      },
    });
  };

  const currencyFormater = (value: any) => {
    let currency = value;
    return currency >= 0 ? `$ ${fixedDecimal(currency, 2).toLocaleString()}` : `($ ${fixedDecimal(Math.abs(currency), 2).toLocaleString()})`;
  };

  const formatData = (type: any, value: any) => {
    if (value === null || value === undefined || value?.trim() === "") {
      return "--";
    } else if (type === "currency") {
      return currencyFormater(value);
    } else if (type === "phone") {
      return formatPhoneNumber(value, "usFormat");
    } else if (type === "date" && moment(value).isValid()) {
      return formatDisplayDate(value, "createDateFormat", "");
    }
    return value;
  };

  // Debouncing search filters on member name and member InsuranceId
  const debounceMemberSearch = debounce((event) => {
    setSearchedName(event.target.value);
    fetchMembersList(event.target.value, searchedId);
  }, 500);
  const debounceMemberIdSearch = debounce((event) => {
    setSearchedId(event.target.value);
    fetchMembersList(searchedName, event.target.value);
  }, 500);

  const handleMemberListTableChange = (pagination: any, filters: any, sorter: any) => {
    if (sorter.order) {
      setSort({ column: sorter.columnKey, order: sorter.order });
    } else {
      setSort({ column: "patient_name", order: "ascend" });
    }
  };

  return (
    <div className="ui-patient-profile">
      <div className="ui-patient-profile__header">
        <div className="ui-patient-profile__header__page-name">
          {/* <div className="ui-patient-profile__header__page-name__path">HealthEM.AI / Patient Profile Snapshot</div> */}
          <div className="ui-patient-profile__header__page-name__heading">
            <img src={dashboardReport} alt="dashboardReport" className="ui-patient-profile__header__page-name__heading__img" />
            <div className="ui-patient-profile__header__page-name__heading__title">Patient Profile</div>
          </div>
        </div>
        <div className="ui-patient-profile__header__multi-select">
          <MultiSelect
            handleSelect={(val) => {
              setSelectedOptions(val);
              // let _patientData: any = [];
              let _patientPersonalData: any = [];
              let _patientTransactionalData: any = [];

              // removing all the optional labels/values
              // _patientData = patientData.filter((item: never) => {
              //   return !patientOptionalData.includes(item);
              // });

              _patientPersonalData = patientPersonalData.filter((item: never) => {
                return !patientOptionalData.includes(item);
              });

              _patientTransactionalData = patientTransactionalDetails.filter((item: never) => {
                return !patientOptionalData.includes(item);
              });

              // adding selected optional labels/values
              val.split("$|").forEach((item: any) => {
                if (patientPersonalDataGroup.includes(item)) {
                  const x = find(patientOptionalData, { label: item });
                  if (!isEmpty(x)) {
                    _patientPersonalData.push(x);
                  }
                } else if (patientTransactionalDataGroup.includes(item)) {
                  const x = find(patientOptionalData, { label: item });
                  if (!isEmpty(x)) {
                    _patientTransactionalData.push(x);
                  }
                }
              });

              // setPatientData(_patientData);
              setPatientPersonalData(_patientPersonalData);
              setPatientTransactionalDetails(_patientTransactionalData);
            }}
            value={selectedOptions}
            options={dropDownOptions}
            loadingOptions={false}
            disabled={false}
            placeholder={"Additional properties"}
          />
        </div>
      </div>

      <div className="ui-patient-profile__list-and-profile">
        {/* table for the searched patient */}
        <div className="spinner-list">
          <div className="ui-patient-profile__list-and-profile__search">
            <div className="ui-patient-profile__list-and-profile__search__input-rules">Enter full or partial details to search a patient</div>
            <Input
              placeholder="Patient Name"
              className="ui-patient-profile__list-and-profile__search__input"
              prefix={<Icon name="patientProfileNameSearch" />}
              onChange={debounceMemberSearch}
              defaultValue={searchedName}
            />
            <Input
              placeholder="Insurance #"
              className="ui-patient-profile__list-and-profile__search__input"
              prefix={<Icon name="patientProfileNameSearch" />}
              onChange={debounceMemberIdSearch}
              defaultValue={searchedId}
            />
          </div>
          <Spin spinning={isPatientListLoading} indicator={<HealthemSpinner size={45} />}>
            <div className="ui-patient-profile__list-and-profile__table-header">Available Members</div>
            <div className="ui-patient-profile__list-and-profile__list">
              <Table
                columns={columns}
                dataSource={patientList}
                locale={TableLocale}
                onChange={handleMemberListTableChange}
                rowClassName={(record: any, index: any) => (record?.patient_id === activePatientId ? "ui-patient-profile__list-and-profile__list__table__selected-row" : "")}
                pagination={{
                  defaultPageSize: 1,
                  showSizeChanger: true,
                  pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                  pageSize: pageSize,
                  current: page,
                  onChange: (pageNumber, pageSizeNumber) => {
                    setPage(pageNumber);
                    setPageSize(pageSizeNumber);
                  },
                }}
                onRow={(record) => {
                  return {
                    onClick: (event) => {
                      setActivePatientId(get(record, "patient_id", "--"));
                      // setIsPatientProfileVisible(true);
                    }, // click row
                  };
                }}
              />
            </div>
          </Spin>
        </div>

        {/* the last table for patient profile */}
        <div className="spinner-data">
          <Spin spinning={isPatientProfileLoading} indicator={<HealthemSpinner size={60} />}>
            <div className="ui-patient-profile__list-and-profile__data">
              {isEmpty(patientData) ? (
                <DataNotFound message={NO_DATA_FOUND}/>
              ) : (
                <>
                  <div className="ui-patient-profile__list-and-profile__data__left">
                    <div className="ui-patient-profile__list-and-profile__data__left__patient-primary-details">
                      {patientData?.map((patientData: any) => {
                        return (
                          <div className={`ui-patient-profile__list-and-profile__data__left__patient-primary-details__item ${patientData?.label === "Name" ? "first-column" : ""}`}>
                            {patientData?.label !== "Name" ? <div className="ui-patient-profile__list-and-profile__data__left__patient-primary-details__item__label">{patientData?.label}</div> : null}
                            <div
                              className={`ui-patient-profile__list-and-profile__data__left__patient-primary-details__item__value ${patientData?.label === "Name" ? "patient-name" : "right-fields"}`}
                              onClick={() => {
                                patientData?.label === "Name" ? goToMemberDetails() : noop();
                              }}
                            >
                              {formatData(patientData?.type, patientData?.value?.toString())}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details">
                      <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__personal-details">
                        {patientPersonalData?.map((item: any) => {
                          return (
                            <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__personal-details__item">
                              <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__personal-details__item__label">{item?.label}</div>
                              <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__personal-details__item__value">
                                <Text ellipsis={true}>
                                  <Tooltip title={formatData(item?.type, item?.value?.toString())}>{formatData(item?.type, item?.value?.toString())}</Tooltip>
                                </Text>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details">
                        <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__header">
                          <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__header__label firstColumn">Fields</div>
                          <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__header__label valueColumn">TTM</div>
                          <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__header__label valueColumn">YTD</div>
                        </div>
                        {patientTransactionalDetails?.map((item: any) => {
                          return (
                            <div className="ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__item">
                              <div
                                className={`ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__item__label ${
                                  highlighted_labels.includes(item?.label) ? "highlightedTransactionalLabel" : ""
                                }`}
                              >
                                {item?.label}
                              </div>
                              <div
                                className={`ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__item__value ${
                                  item?.type === "currency" && item?.value1 < 0 ? "highlightedTransactionalValue" : ""
                                }`}
                              >
                                {formatData(item?.type, item?.value1?.toString())}
                              </div>
                              <div
                                className={`ui-patient-profile__list-and-profile__data__left__patient-secondary-details__transactional-details__item__value ${
                                  item?.type === "currency" && item?.value2 < 0 ? "highlightedTransactionalValue" : ""
                                }`}
                              >
                                {formatData(item?.type, item?.value2?.toString())}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Spin>
          <div
            className={classNames({
              "spinner-data__refresh-data": true,
              "spinner-data__hide": isEmpty(patientData),
            })}
          >
            <RefreshData />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientProfileReport;
